export default __webpack_public_path__ + "static/media/PlaceSwitch.6ec99006.svg";